import * as React from "react";
import Floater from "react-floater";

const Floatipy = props => (
  <Floater
    event={"hover"}
    content={props.tooltip}
    offset={5}
    placement={"bottom"}
    styles={{
      wrapper: {
        cursor: "default"
      },
      container: {
        textAlign: "center",
        minHeight: "auto",
        padding: 20,
        borderRadius: 5
      },
      floater: {
        zIndex: 5000000
      },
      arrow: {
        margin: 4
      }
    }}
  >
    {props.children}
  </Floater>
);

export default Floatipy;



// WEBPACK FOOTER //
// ./src/components/Floatipy.js